import { render, staticRenderFns } from "./PlatformChat.vue?vue&type=template&id=03c3fa5e&"
import script from "./PlatformChat.vue?vue&type=script&lang=js&"
export * from "./PlatformChat.vue?vue&type=script&lang=js&"
import style0 from "./PlatformChat.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports